export default [
  'copX',
  'copY',
  'leftCOPX',
  'leftCOPY',
  'rightCOPX',
  'rightCOPY',
];
